import Reveal from "@/components/Reveal";

const FORGE_IMG = "/equipe.png";
const LOGO_IMG = "/logo.png";

const BULLETS = [
    "Impressão FDM com múltiplos materiais e cores",
    "Acabamento manual, peça a peça",
    "Suporte completo: do modelo ao pós-processamento",
];

export const SobreSection = () => (
    <section id="sobre" className="py-24 md:py-32" data-testid="about-section">
        <div className="zf-container grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
            <Reveal className="relative pb-8 pr-4 md:pr-10">
                <div className="clip-corner relative overflow-hidden border border-forge-line">
                    <img
                        src={FORGE_IMG}
                        alt="Equipe Ziggs Forge em ação"
                        loading="lazy"
                        className="aspect-[4/3] w-full object-cover object-top"
                    />
                </div>
                <div className="absolute -bottom-6 right-0 w-32 rotate-3 border-4 border-forge-ink shadow-2xl md:w-44" data-testid="about-logo-card">
                    <img src={LOGO_IMG} alt="Logotipo da Ziggs Forge" loading="lazy" className="w-full" />
                </div>
                <span className="absolute -left-3 -top-3 h-16 w-16 border-l-2 border-t-2 border-forge-yellow" aria-hidden />
            </Reveal>

            <div>
                <Reveal>
                    <p className="zf-eyebrow">Sobre nós</p>
                    <h2 className="mt-4 font-display text-3xl font-bold uppercase leading-tight text-forge-paper md:text-5xl">
                        A forja onde ideias viram matéria
                    </h2>
                </Reveal>
                <Reveal delay={0.08}>
                    <p className="mt-6 leading-relaxed text-forge-dim">
                        A Ziggs Forge nasceu da obsessão por transformar arquivos digitais em objetos que dá para
                        segurar na mão. O que começou como hobby virou bancada de trabalho: impressoras rodando,
                        filamento chegando e ideias novas todos os dias.
                    </p>
                </Reveal>
                <Reveal delay={0.14}>
                    <p className="mt-4 leading-relaxed text-forge-dim">
                        Cada peça é impressa, limpa, inspecionada e só sai da forja quando está no ponto. Do
                        primeiro esboço ao acabamento final, você acompanha tudo de perto.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <ul className="mt-8 space-y-3">
                        {BULLETS.map((b) => (
                            <li key={b} className="flex items-start gap-3 text-sm text-forge-paper md:text-base">
                                <span className="mt-1.5 inline-block h-2 w-2 shrink-0 rotate-45 bg-forge-yellow" />
                                {b}
                            </li>
                        ))}
                    </ul>
                </Reveal>
            </div>
        </div>
    </section>
);

export default SobreSection;
